<div class="modal-signup modal-content" >
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-0px padding-left-10px">

        Select Material Availability

        <button type="button" class="close" data-dismiss="modal"
                (click)="activeModal.dismiss('Cross click')"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="card-body padding-bottom-0px padding-right-0px margin-left-0px padding-left-0px padding-top-0px">
        <div class="row border-top border-bottom bk-color-light margin-left-zero margin-right-0px">
          <div class="col-md-4  text-align-center padding-right-0px padding-left-0px border-right-1px">
            <div class="margin-top-10"><h4 class=" font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Material Name</h4></div>
            <div class="margin-bottom-10px"><h4 class="margin-bottom-0px display-inline color-Checkin font-weight-bold" *ngIf="MaterialName">{{MaterialName}}</h4></div>
          </div>
          <div class="col-md-4  text-align-center padding-right-0px padding-left-0px border-right-1px">
            <div class="margin-top-10"><h4 class="font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Store Location</h4></div>
            <div class="margin-bottom-10px"><h4 class="margin-bottom-0px display-inline color-Assign" *ngIf="StroreLocation">{{StroreLocation}}</h4></div>
          </div>
          <div class="col-md-4 text-align-center padding-right-0px padding-left-0px border-right-1px">
            <div class="margin-top-10"><h4 class=" font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Consumption Group</h4></div>
            <div class="margin-bottom-10px"><h4 class="margin-bottom-0px display-inline" *ngIf="ConsumptionGroup">{{ConsumptionGroup}}</h4> </div>
          </div>
          <!--<div class="col-md-3 text-align-center padding-right-0px padding-left-0px border-right-1px">
            <div class="margin-top-10"><h4 class=" font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Required Qty</h4></div>
            <div class="margin-bottom-10px"><h4 class="margin-bottom-0px display-inline color-checkout"></h4></div>
          </div>-->


          <!--<div class="col-md-3  text-align-center padding-right-0px padding-left-0px border-right-1px">
    <div class="margin-top-10"><h4 class=" font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Item Name</h4></div>
    <div class="margin-bottom-10px"><h4 class="margin-bottom-0px display-inline"> Consultant</h4></div>
  </div>
  <div class="col-md-3  text-align-center padding-right-0px padding-left-0px border-right-1px">
    <div class="margin-top-10"><h4 class="font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Requst Qty</h4></div>
    <div class="margin-bottom-10px"><h4 class="margin-bottom-0px display-inline">2</h4></div>
  </div>-->
        </div>
        <!--<div class="row">
          <div class="col-md-12 padding-right-9px padding-left-10px">
            <div class="row font-size-14 margin-top-10 margin-left-0px">
              <div class="col-md-2">
                <h4 class="margin-bottom-0px margin-top-3px">Selected Batch </h4>
              </div>:
              <div class="col-md-7  padding-left-10px my-profile-form">

                <div class="form-group margin-bottom-0px">
              
                  <h4 class="margin-bottom-0px  margin-top-3px"></h4>


                </div>


              </div>

            </div>
          </div>
          
        </div>-->
        <div class="row padding-top-10px">
          <div class="col-md-11 margin-left-15px">
            <h4 class="margin-bottom-0px color-Assign font-size-14 font-weight-bold">Material Inventory</h4>
          </div>
          <div class="col-md-12" *ngIf="length>0">
            <div class="chatsd product-chart-wrapper product-chat-height-335px agreement-chart-wrapper ps ps2 padding-lrt " data-ps-id="dfsfsde">
              <div class="table-component">
                <div class="table-responsive overflow-x">


                  <table class="table table-striped margin-left-20p table-fixed"
                         cols="auto,2*,*,*,*,*,*,*">

                    <thead class="">
                      <tr>





                        <th class=" padding-top-4px padding-bottom-4px th-sticky padding-left-0px text-align-center">
                          Batch
                        </th>
                        <th class="padding-top-4px padding-bottom-4px th-sticky padding-left-2px">
                          Supplier
                        </th>
                        <th class="padding-top-4px padding-bottom-4px th-sticky padding-right-5px">
                          Av.QTy
                        </th>
                        <th class="text-align-center padding-top-4px padding-bottom-4px th-sticky">
                          Entry Date
                        </th>
                        <th class="text-align-center padding-top-4px padding-bottom-4px th-sticky">
                          Expiry Date
                        </th>
                        <th class="padding-top-4px padding-bottom-4px th-sticky">
                          Req.QTY
                        </th>







                        <!--<th class="">

              </th>-->
                        <th class="padding-top-4px padding-bottom-4px th-sticky">

                        </th>






                      </tr>
                    </thead>

                    <tbody class="table-body">
                      <tr *ngFor="let l of CurrentMaterialBatchInaStoreController2;let i = index">




                        <td class="text-align-center td-padding-tb padding-right-0px padding-left-2px">{{l.BatchNo}}</td>
                        <td class="text-align-left td-padding-tb padding-right-0px padding-left-0px">{{l.SupplierShortName}}</td>
                        <td class="text-align-right td-padding-tb ">{{l.AvailableQuantity}}</td>
                        <td class="td-padding-tb text-align-center padding-right-0px"> <label>{{l.EntryDate | date:'MMM-dd-yyyy'}}</label></td>



                        <td class="td-padding-tb text-align-center padding-right-0px">
                          <label *ngIf="IsNotExpired(l)">{{l.ExpiryDate | date:'MMM-dd-yyyy'}}</label>
                          <a *ngIf="!IsNotExpired(l)" class="color-red">{{l.ExpiryDate | date:'MMM-dd-yyyy'}}</a>
                        </td>
                        <!--<td class="td-padding-tb text-align-center padding-right-0px">
                          <label>
                            {{l.ExpiryDate | date:'MMM-dd-yyyy'}}
                          </label>
                        </td>-->
                        <td class="text-align-center td-padding-tb">
                          <input type="text" class="form-control text-align-right td-width-82px" placeholder=""
                                 [(ngModel)]="l.Quantity" (input)="IsQtyNotAvlbl(l)"
                                 maxlength="5" pattern="^[\0-9,._\-?]*$" #Endometrium="ngModel" required>
                          <small class="form-text text-danger"
                                 *ngIf="(!Endometrium.valid && (Endometrium.dirty || Endometrium.touched) && Endometrium.errors.required )">(Field cannot be left blank)</small>
                          <small class="form-text text-danger"
                                 *ngIf="(!Endometrium.valid && Endometrium.errors.pattern)">(only numbers are allowed)</small>

                        </td>
                        <td class=" td-padding-tb ">

                          <!--<a class="nav-link-hand education-navlink font-size-16px color-Assign" title="Edit Plan" (click)="Editrow()" *ngIf="Add">
      <span class="badge"><i class="fas fa-pencil-alt"></i></span>
    </a>-->
                          <!--<button type="submit" (click)="Editrow(l)" class="button-service-save font-size-16px color-secondary nav-link-hand margin-left-3px" title="Save" *ngIf="!l.Edit"><i class="fas fa-pencil-alt"></i></button>-->
                          <button type="button"
                                  *ngIf="IsNotExpired(l) && (l.Quantity > 0) && (l.Quantity <= l.AvailableQuantity)"
                                  class="btn font-size-13px actions-btn-prime" (click)="activeModal.close(l)">
                            Select
                          </button>
                          <!--<button type="submit" (click)="OnClear(l)" class="button-service-save font-size-16px color-secondary nav-link-hand" title="Save" *ngIf="l.Edit"><i class="far fa-save"></i></button>
    <button type="submit" (click)="OnClear(l)" class="button-service-save font-size-16px  nav-link-hand color-Rejected" title="Save" *ngIf="l.Edit"><i class="fa fa-times"></i></button>-->

                        </td>



                      </tr>
                    </tbody>



                  </table>
                </div>
              </div>
              </div>
            </div>
            <div *ngIf="length==0" class="margin-left-auto margin-right-auto">
              <label class="margin-bottom-0px color-Assign font-size-18px"> Batches are not avilable for this Material</label>
            </div>
          </div>
      </div>
    </div>
  </div>
</div>

